import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";
//import useStaticContext from "@hooks/useStaticContext";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";

import Alert from "@material-ui/lab/Alert";
import Link from "@material-ui/core/Link";

import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ContentBadgeDialog from "./ContentBadgeDialog";

const ContentBadge = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const { sidePitchCost, sidePitchArticle } = useConstants("ContentViewModel");

	return (
		<div>
			<Alert
				variant="outlined"
				severity="info"
				icon={<VerifiedUserIcon color="primary" />}
			>
				<Box fontSize={14} lineHeight={1.6}>
					{store.content.contentType === "article" ? (
						<>{sidePitchArticle}</>
					) : (
						<>{sidePitchCost}</>
					)}{" "}
					We adhere to strict{" "}
					<Link onClick={handleClickOpen} color={"primary"}>
						editorial integrity
					</Link>
					.
				</Box>
				{store.content.contentType === "cost guide" && (
					<Box fontSize={14} lineHeight={1.6} mt={4}>
						Want to use this data?{" "}
						<Link onClick={handleClickOpen} color={"primary"}>
							Learn more
						</Link>
					</Box>
				)}
			</Alert>

			{open && (
				<ContentBadgeDialog close={handleClose} open={handleClickOpen} />
			)}
		</div>
	);
};

ContentBadge.propTypes = {};
export default ContentBadge;
